import { render, staticRenderFns } from "./DetailsProductComponent.vue?vue&type=template&id=2b6e4a84&scoped=true"
import script from "./DetailsProductComponent.vue?vue&type=script&lang=js"
export * from "./DetailsProductComponent.vue?vue&type=script&lang=js"
import style0 from "./DetailsProductComponent.vue?vue&type=style&index=0&id=2b6e4a84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6e4a84",
  null
  
)

export default component.exports